import * as React from 'react';

export const FadedOverlay = ({fadeLeft, fadeRight, isBigger}:{fadeLeft: boolean, fadeRight: boolean, isBigger?: boolean}) => {
    return (
        <div className="w-full h-full absolute top-0 left-0 pointer-events-none">
        {fadeLeft && <FadedOverlayItem isLeft={true} isBigger={isBigger}></FadedOverlayItem>}
            {fadeRight && <FadedOverlayItem isLeft={false} isBigger={isBigger}></FadedOverlayItem>}
        </div>
    )
}

const FadedOverlayItem = ({ isLeft, isBigger }: { isLeft: boolean, isBigger?: boolean }) => {
    return (
        <div className={`absolute h-full from-white 
        ${isLeft ? 'left-0 bg-gradient-to-r' : 'right-0 bg-gradient-to-l'}
        ${isBigger ? 'w-12 xm:w-16 sm:w-20' : 'w-8 xm:w-12 sm:w-16'}`}/>
    )
}